import {getCookie} from '../app.js';

class LearnerTodos extends HTMLElement {
    connectedCallback() {
        const c_id = this.id;
        const c_websiteurl = getCookie('WEBSITE_URL');
        const _self = this;
        function safeParse(data) {
            if (typeof data === 'string') { try { return JSON.parse(data); } catch(e) { return data; } }
            return data;
        }

        this.innerHTML =
            "<div style='padding:4px 0 12px;'>" +
            "  <div style='display:flex;align-items:center;justify-content:space-between;margin-bottom:12px;'>" +
            "    <h4 style='margin:0;font-size:15px;font-weight:600;'>TO DO LIST</h4>" +
            "    <button type='button' id='btn-add-todo-item' class='btn btn-sm btn-primary'>+ Add To Do</button>" +
            "  </div>" +
            "  <div id='todos-list'><div style='color:#9ca3af;font-size:13px;'>Loading...</div></div>" +
            "  <div id='add-todo-form' style='display:none;border:1px solid #dee2e6;border-radius:6px;padding:12px;margin-top:12px;'>" +
            "    <div style='font-size:13px;font-weight:600;margin-bottom:8px;'>New To Do Item</div>" +
            "    <input type='text' id='new-todo-name' class='form-control form-control-sm' placeholder='Task name' style='margin-bottom:6px;'>" +
            "    <textarea id='new-todo-details' class='form-control form-control-sm' rows='2' placeholder='Details (optional)'></textarea>" +
            "    <div style='margin-top:8px;display:flex;gap:8px;'>" +
            "      <button type='button' id='btn-save-todo' class='btn btn-sm btn-primary'>SAVE</button>" +
            "      <button type='button' id='btn-cancel-todo' class='btn btn-sm btn-outline-secondary'>Cancel</button>" +
            "    </div>" +
            "  </div>" +
            "</div>";

        function updateTabBadge(countAll, countCompleted) {
            var bg = countAll === 0 ? '#d1d5db' : (countCompleted === countAll ? '#16a34a' : '#4980b5');
            var color = countAll === 0 ? '#6b7280' : '#fff';
            var text = countAll === 0 ? '0' : (countCompleted + '/' + countAll);
            var label = 'To Do <span style="background:' + bg + ';color:' + color + ';border-radius:10px;font-size:10px;padding:1px 6px;font-weight:600;vertical-align:middle;">' + text + '</span>';
            $('[data-tab="todos"]').html(label);
        }

        function renderTodos() {
            var list = _self.querySelector('#todos-list');
            list.innerHTML = '<div style="color:#9ca3af;font-size:13px;">Loading...</div>';

            $.get(c_websiteurl + 'app.php/todos/json/?learner_id=' + c_id)
                .done(function(data) {
                    var todos = safeParse(data);
                    if (!Array.isArray(todos) || todos.length === 0) {
                        list.innerHTML = '<div style="color:#9ca3af;font-size:13px;padding:8px 0;">No to do items yet.</div>';
                        updateTabBadge(0, 0);
                        return;
                    }

                    var countAll = todos.length;
                    var countCompleted = todos.filter(function(t) { return t.completed == 1; }).length;
                    updateTabBadge(countAll, countCompleted);

                    var html = '';
                    todos.forEach(function(todo) {
                        var done = todo.completed == 1;
                        var rowStyle = done
                            ? 'border:1px solid #d1fae5;border-radius:6px;padding:10px 12px;margin-bottom:8px;background:#f0fdf4;'
                            : 'border:1px solid #dee2e6;border-radius:6px;padding:10px 12px;margin-bottom:8px;';
                        var nameStyle = done ? 'text-decoration:line-through;color:#6b7280;' : 'font-weight:600;';
                        html += '<div class="todo-item" data-todoid="' + todo.id + '" style="' + rowStyle + '">'
                            + '<div style="display:flex;align-items:flex-start;gap:10px;">'
                            + '<input type="checkbox" class="todo-check" data-id="' + todo.id + '" ' + (done ? 'checked' : '') + ' style="margin-top:3px;cursor:pointer;flex-shrink:0;">'
                            + '<div style="flex:1;min-width:0;">'
                            + '<div class="todo-display-' + todo.id + '">'
                            + '<div style="' + nameStyle + 'font-size:13px;">' + todo.name + '</div>'
                            + (todo.details ? '<div style="font-size:12px;color:#6b7280;margin-top:2px;">' + todo.details + '</div>' : '')
                            + (done && todo.completed_at_formatted ? '<div style="font-size:11px;color:#16a34a;margin-top:4px;">' + todo.completed_at_formatted + '</div>' : '')
                            + '</div>'
                            + '<div class="todo-edit-form-' + todo.id + '" style="display:none;">'
                            + '<input type="text" class="form-control form-control-sm edit-todo-name" value="' + todo.name.replace(/"/g, '&quot;') + '" style="margin-bottom:4px;">'
                            + '<textarea class="form-control form-control-sm edit-todo-details" rows="2" style="margin-bottom:4px;">' + (todo.details || '') + '</textarea>'
                            + '<div style="display:flex;gap:6px;">'
                            + '<button class="btn btn-sm btn-primary edit-todo-save" data-id="' + todo.id + '">Save</button>'
                            + '<button class="btn btn-sm btn-outline-secondary edit-todo-cancel" data-id="' + todo.id + '">Cancel</button>'
                            + '</div>'
                            + '</div>'
                            + '</div>'
                            + '<div style="display:flex;gap:4px;flex-shrink:0;">'
                            + '<button class="btn btn-sm todo-edit-btn" data-id="' + todo.id + '" style="padding:2px 6px;font-size:11px;" title="Edit"><img src="/img/tabler/edit.svg" style="height:13px;width:13px;"></button>'
                            + '<button class="btn btn-sm btn-outline-danger todo-delete-btn" data-id="' + todo.id + '" style="padding:2px 6px;font-size:11px;" title="Delete"><img src="/img/tabler/trash.svg" style="height:13px;width:13px;"></button>'
                            + '</div>'
                            + '</div>'
                            + '</div>';
                    });
                    list.innerHTML = html;

                    // Bind check/uncheck
                    _self.querySelectorAll('.todo-check').forEach(function(chk) {
                        chk.addEventListener('change', function() {
                            var completed = this.checked ? 1 : 0;
                            $.post(c_websiteurl + 'app.php/todos/checkoruncheck/', { id: this.dataset.id, completed: completed })
                                .done(function() { renderTodos(); });
                        });
                    });

                    // Bind delete
                    _self.querySelectorAll('.todo-delete-btn').forEach(function(btn) {
                        btn.addEventListener('click', function() {
                            if (!confirm('Delete this to do item?')) return;
                            $.post(c_websiteurl + 'app.php/todos/delete/', { id: this.dataset.id })
                                .done(function() { renderTodos(); });
                        });
                    });

                    // Bind edit - toggle inline form
                    _self.querySelectorAll('.todo-edit-btn').forEach(function(btn) {
                        btn.addEventListener('click', function() {
                            var tid = this.dataset.id;
                            var display = _self.querySelector('.todo-display-' + tid);
                            var form = _self.querySelector('.todo-edit-form-' + tid);
                            if (display) display.style.display = 'none';
                            if (form) form.style.display = 'block';
                        });
                    });

                    // Bind inline edit cancel
                    _self.querySelectorAll('.edit-todo-cancel').forEach(function(btn) {
                        btn.addEventListener('click', function() {
                            var tid = this.dataset.id;
                            var display = _self.querySelector('.todo-display-' + tid);
                            var form = _self.querySelector('.todo-edit-form-' + tid);
                            if (display) display.style.display = '';
                            if (form) form.style.display = 'none';
                        });
                    });

                    // Bind inline edit save
                    _self.querySelectorAll('.edit-todo-save').forEach(function(btn) {
                        btn.addEventListener('click', function() {
                            var tid = this.dataset.id;
                            var form = _self.querySelector('.todo-edit-form-' + tid);
                            var name = form.querySelector('.edit-todo-name').value.trim();
                            if (!name) return;
                            $.post(c_websiteurl + 'app.php/todos/update/', {
                                id: tid,
                                name: name,
                                details: form.querySelector('.edit-todo-details').value.trim()
                            }, function() {
                                renderTodos();
                            });
                        });
                    });
                });
        }

        // Add todo form toggle
        var _btnAdd = _self.querySelector('#btn-add-todo-item');
        var _addForm = _self.querySelector('#add-todo-form');
        if (_btnAdd) {
            _btnAdd.addEventListener('click', function() {
                _addForm.style.display = _addForm.style.display === 'none' ? 'block' : 'none';
                if (_addForm.style.display === 'block') {
                    _self.querySelector('#new-todo-name').focus();
                }
            });
        }

        var _btnCancel = _self.querySelector('#btn-cancel-todo');
        if (_btnCancel) {
            _btnCancel.addEventListener('click', function() {
                _addForm.style.display = 'none';
                _self.querySelector('#new-todo-name').value = '';
                _self.querySelector('#new-todo-details').value = '';
            });
        }

        var _btnSave = _self.querySelector('#btn-save-todo');
        if (_btnSave) {
            _btnSave.addEventListener('click', function() {
                var name = _self.querySelector('#new-todo-name').value.trim();
                if (!name) return;
                $.post(c_websiteurl + 'app.php/todos/store/', {
                    learner_id: c_id,
                    name: name,
                    details: _self.querySelector('#new-todo-details').value.trim()
                }, function() {
                    _self.querySelector('#new-todo-name').value = '';
                    _self.querySelector('#new-todo-details').value = '';
                    _addForm.style.display = 'none';
                    renderTodos();
                });
            });
        }

        if (c_id > 0) {
            renderTodos();
        }
    }
}

window.customElements.define('learner-todos', LearnerTodos);
